import React from "react";
import HousekeepingStatusBoardActions from "./actions/HousekeepingStatusBoardActions";
import DateHelper from "../DateHelper/DateHelper";
import DashboardDatePicker from '../DashboardDatePicker/DashboardDatePicker';
import { addDays, isSameDay } from 'date-fns'

class HousekeepingStatusBoardHeader extends React.Component {
    constructor(props) {
        super(props);

        this.onChangeDate = this.onChangeDate.bind(this);
        this.onToday = this.onToday.bind(this);
        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onChangeView = this.onChangeView.bind(this);
    }

    render() {
        return (
            <div className="row dashboard-buttons">
                <div className="col-sm-7 flexed content-right dashboard-range-picker-wrapper">
                    <button type="button" className="prev-button btn btn-secondary" onClick={this.onPrev}>
                        <span className="icon ss-left"></span>
                    </button>
                    {
                        isSameDay(new Date(this.props.currentDate), new Date())
                            ?
                            <DashboardDatePicker
                                classNames={'current-date'}
                                selectedDate={this.props.currentDate}
                                dateFormat={this.props.dateFormat}
                                onChange={this.onChangeDate}
                            />
                            :
                            <DashboardDatePicker
                                selectedDate={this.props.currentDate}
                                dateFormat={this.props.dateFormat}
                                onChange={this.onChangeDate}
                            />
                    }
                    <button type="button" className="next-button btn btn-secondary" onClick={this.onNext}>
                        <span className="icon ss-right"></span>
                    </button>
                </div>
                <div className="col-sm-5 flexed content-right dashboard-view-wrapper">
                    <select
                        className="form-control dashboard-view-select"
                        value={this.props.activeTab}
                        onChange={this.onChangeView}
                    >
                        <option value="daily">{I18n.t("dashboard_view_day")}</option>
                        <option value="weekly">{I18n.t("dashboard_view_week")}</option>
                        <option value="monthly">{I18n.t("dashboard_view_month")}</option>
                    </select>
                </div>
            </div>
        );
    }

    onChangeDate(date) {
        HousekeepingStatusBoardActions.gotoDate(date);
    }

    onToday() {
        HousekeepingStatusBoardActions.gotoDate(new Date());
    }

    onPrev() {
        var prevDate = new Date(this.props.currentDate);

        if (this.props.activeTab === "weekly") {
            prevDate.setDate(prevDate.getDate() - 7);
        } else if (this.props.activeTab === "monthly") {
            prevDate.setDate(prevDate.getDate() - 31);
        } else {
            prevDate.setDate(prevDate.getDate() - 1);
        }

        HousekeepingStatusBoardActions.gotoDate(prevDate);
    }

    onNext() {
        var nextDate = new Date(this.props.currentDate);

        if (this.props.activeTab === "weekly") {
            nextDate.setDate(nextDate.getDate() + 7);
        } else if (this.props.activeTab === "monthly") {
            nextDate.setDate(nextDate.getDate() + 31);
        } else {
            nextDate.setDate(nextDate.getDate() + 1);
        }

        HousekeepingStatusBoardActions.gotoDate(nextDate);
    }

    onChangeView(e) {
        e.preventDefault();
        HousekeepingStatusBoardActions.setActiveTab(e.target.value);
    }
}

export default HousekeepingStatusBoardHeader